import { useEffect, useState } from 'react'
import Input from 'components/input/input/input'
import Select from 'components/input/select/select'
import Checkbox from 'components/input/checkbox/checkbox'
import InputGroup from 'components/input-group/input-group'
import InputField from 'components/input-field/input-field'
import deliveries from 'utils/data/deliveries'
import countries, { eu, global } from 'utils/data/countries'
import Infoblock from 'components/infoblock/infoblock'
import Radio from 'components/input/radio/radio'
// import styles from './delivery-settings.module.scss'
import stations from 'utils/data/stations'

const dutiesPayers = [
    { value: 'receiver', name: 'Muito mokesčius apmoka gavėjas (rekomenduojama)' },
    { value: 'sender', name: 'Muito mokesčius apmoka siuntėjas' }
]

function DeliverySettings({ item, forAccount, handleChange }) {
    const [euCountries, setEuCountries] = useState('')
    const [globalCountries, setGlobalCountries] = useState('')
    const itemDeliveries = item.deliveries || ''
    const itemDeliveryPrices = item.delivery_prices || ''

    useEffect(() => {
        const euCountries = countries
            .filter(c => eu.includes(c.value))
            .map(c => c.name)
            .join(', ')

        const globalCountries = countries
            .filter(c => global.includes(c.value))
            .map(c => c.name)
            .join(', ')

        setEuCountries(euCountries)
        setGlobalCountries(globalCountries)
    }, [])

    const getInfo = name => {
        if (name === 'eu') {
            return euCountries
        }
        if (name === 'global') {
            return globalCountries
        }
    }

    return (
        <>
            <InputGroup>
                {forAccount ? (
                    <span>Per kiek darbo dienų prekės išsiunčiamos?</span>
                ) : (
                    <Checkbox
                        name="standard_preparation"
                        value={item.standard_preparation}
                        onChange={handleChange}
                        label="Standartinis laikas iki išsiuntimo"
                        info="Pažymėjus šį laukelį bus naudojamas bendras laikas iki išsiuntimo iš parduotuvės nustatymų puslapio."
                    />
                )}
                <div>
                    {(forAccount || !item.standard_preparation) && (
                        <InputGroup forceMobile>
                            <Input
                                type="number"
                                name="preparation_time_from"
                                value={item.preparation_time_from}
                                onChange={handleChange}
                                min={1}
                                step={1}
                                required
                                label="Nuo"
                            />
                            <Input
                                type="number"
                                name="preparation_time_to"
                                value={item.preparation_time_to}
                                onChange={handleChange}
                                min={1}
                                step={1}
                                required
                                label="Iki"
                            />
                        </InputGroup>
                    )}
                </div>
            </InputGroup>
            {forAccount && (
                <InputGroup>
                    <div>
                        <Checkbox
                            name="free_shipping"
                            value={item.free_shipping}
                            onChange={handleChange}
                            label="Nemokamas pristatymas nuo"
                        />
                        {!!item.free_shipping &&<Checkbox
                            name="free_shipping_lt"
                            value={item.free_shipping_lt}
                            onChange={handleChange}
                            label="Galioja tik siunčiant Lietuvoje"
                            info="Pažymėkite čia, jeigu norite, kad nemokamas pristatymas galiotų tik siunčiant Lietuvoje."
                        />}
                    </div>
                    {!!item.free_shipping && (
                        <Input
                            type="number"
                            name="free_shipping_from"
                            value={item.free_shipping_from}
                            onChange={handleChange}
                            label="Nemokamas pristatymas nuo"
                            min={0}
                            info="Minimali užsakymo suma, nuo kurios įsigalioja nemokamas pristatymas"
                        />
                    )}
                </InputGroup>
            )}
            {!forAccount && (
                <div>
                    <Checkbox
                        name="standard_delivery"
                        value={item.standard_delivery}
                        onChange={handleChange}
                        label="Standartinis siuntimas"
                        info="Siuntimas pagal bendrus paskyros nustatymus"
                    />
                </div>
            )}
            {(forAccount || !item.standard_delivery) && (
                <InputField label="Siuntimo būdai">
                    {deliveries.map(delivery => (
                        <InputGroup key={delivery.value}>
                            <Checkbox
                                name={`deliveries[${delivery.value}]`}
                                value={itemDeliveries[delivery.value]}
                                onChange={e =>
                                    handleChange({
                                        name: 'deliveries',
                                        value: {
                                            ...itemDeliveries,
                                            [delivery.value]: e.target.checked ? 1 : 0
                                        }
                                    })
                                }
                                info={getInfo(delivery.value)}
                                label={delivery.name}
                            />
                            {!!itemDeliveries[delivery.value] &&
                                (delivery.value == 'from_address' ? (
                                    <Input
                                        type="text"
                                        name="from_address"
                                        required
                                        value={item.from_address}
                                        onChange={handleChange}
                                        label="Adresas"
                                        info="Jeigu prekių negalima atsiimti iš karto, tuomet papildomai nurodykite kaip pirkėjas bus informuotas, kad jau gali atvykti"
                                    />
                                ) : delivery.value == 'bus_station' ? (
                                    <Select
                                        type="select"
                                        name="from_station"
                                        required
                                        options={stations}
                                        value={item.from_station}
                                        onChange={handleChange}
                                        label="Išsiuntimo stotis"
                                        info="Pristatymo išlaidas apmoka gavėjas atsiimdamas prekes autobusų stotyje."
                                    />
                                ) : (
                                    <Input
                                        type="number"
                                        name={`delivery_prices[${delivery.value}]`}
                                        value={itemDeliveryPrices[delivery.value]}
                                        onChange={e =>
                                            handleChange({
                                                name: 'delivery_prices',
                                                value: {
                                                    ...itemDeliveryPrices,
                                                    [delivery.value]: e.target.value
                                                }
                                            })
                                        }
                                        label="Kaina (EUR)"
                                        min={0}
                                        step={0.01}
                                    />
                                ))}
                        </InputGroup>
                    ))}
                    {!!itemDeliveries.global && (
                        <>
                            <hr className="mb24" />
                            <div className="mb36">
                                Siunčiant prekes į <b>ne Europos Sąjungos</b> šalis gali būti taikomi muito mokesčiai,
                                kuriuos apmoka arba pardavėjas, arba siuntėjas. Todėl jums reikia pasirinkti:
                                <br />
                                <br />
                                <Radio
                                    name="duties_payer"
                                    value={item.duties_payer}
                                    onChange={handleChange}
                                    options={dutiesPayers}
                                    required
                                />
                                {item.duties_payer === 'receiver' && (
                                    <Infoblock>
                                        Siunčiant prekes per Lietuvos paštą ar kitą jūsų pasirinktą kurjerį pasirinkite{' '}
                                        <b>neapmokėti</b> mokesčių.
                                    </Infoblock>
                                )}
                                {item.duties_payer === 'sender' && (
                                    <Infoblock>
                                        Prie siuntimo į kitas ne Europos Sąjungos šalis kainos pridėkite muito
                                        mokesčiams numatytą sumą (įvertinkite tai, kad siunčiant į skirtingas šalis
                                        taikomi skirtingo dydžio mokesčiai).
                                        <br />
                                        <br />
                                        Siunčiant prekes per Lietuvos paštą ar kitą jūsų pasirinktą kurjerį nepamirškite{' '}
                                        <b>apmokėti</b> mokesčių.
                                    </Infoblock>
                                )}
                            </div>
                        </>
                    )}
                </InputField>
            )}
            <Checkbox
                name="return_guarantee"
                value={item.return_guarantee}
                onChange={handleChange}
                label="Galioja 14 d. grąžinimo garantija"
                info="Pirkėjas turi teisę grąžinti prekes ir atgauti sumokėtus pinigus nenurodydamas priežasties per 14 (keturiolika) dienų, išskyrus prekes ar atvejus, kurie patenka į LR Civilinio kodekso 6.228(10) str. numatytas išimtis. (pvz.: pagal individualų pirkėjo užsakymą pagamintos prekės, dėl higienos priežasčių negrąžinamos prekės, išpakuota kosmetika, leidiniai."
            />
        </>
    )
}

export default DeliverySettings
